// src/pages/PostLogout.jsx
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const PostLogout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Prefer hash value (from #next=...) to avoid expanding Allowed Logout URLs
    const hash = new URLSearchParams(location.hash.replace('#', ''));
    const search = new URLSearchParams(location.search);
    const next = hash.get('next') || search.get('next') || '/';
    navigate(next || '/', { replace: true });
  }, [location, navigate]);

  return null;
};

export default PostLogout;

